import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useMHRDocumentModal = (customerID: string, documentID: string, repositoryID: string) => {
  const { data, error, loading } = useQuery(
    graphql(`
      query mhrGetDocument($customerID: String, $documentID: String, $repositoryID: String) {
        mhrGetDocument(customerId: $customerID, documentId: $documentID, repositoryId: $repositoryID) {
          html
          ok
          error
          documentId
          uniqueRepositoryId
        }
      }
    `),
    {
      variables: {
        customerID,
        documentID,
        repositoryID,
      },
    },
  );

  return {
    ok: data?.mhrGetDocument?.ok ?? false,
    loading,
    error: error ? 'Error loading document view' : data?.mhrGetDocument?.error,
    html: data?.mhrGetDocument?.html,
    documentId: data?.mhrGetDocument?.documentId,
    uniqueRepositoryId: data?.mhrGetDocument?.uniqueRepositoryId,
  };
};
